<template>
	<section :id="['container-' + index + '-' + unitListData.type]" :class="['container-' + unitListData.type]">
		<div class="unit-table" :class="{ 'container-xl': isMultiblock == 'false' }">
			<div class="row">
				<div class="col-md-12">
					<h2 v-if="unitListData.config.title">{{ unitListData.config.title }}</h2>

					<div class="unit-table-inner">
						<template v-for="(units, index) in unitListData.config.tableBody" :key="index">
							<div class="unit-list">
								<div class="row">
									<template v-for="(unitBody, index2) in unitListData.config.tableBody[index]" :key="index2">
										<div class="table-row col-md-6" v-if="unitBody !== '' && unitBody !=='Nein' && unitBody !=='keine Angabe' && unitBody != '-'">
											<div class="row">
												<template v-for="(unitHeader, index1) in unitListData.config.tableHeader" :key="index1">
													<div class="col-6 table-header" v-if="index1 == index2">
														<span>{{ unitHeader }}</span>
													</div>
												</template>
		
												<div class="col-6 table-body">
													<span>{{ unitBody }}</span>
												</div>
											</div>
										</div>
									</template>
								</div>
							</div>
						</template>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>

export default {
	props: {
		unitListData: {
			type: Object
		},
		index: {
			type: Number
		},
		isMultiblock: {
			type: String
		}
	}
};

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "@/assets/scss/design-aachen/unitlistComponent.scss";
</style>;